module.exports = __webpack_public_path__ + "static/banner-four-shape8-d2cd33b04009c5007f808b7040530feb.png";